module.exports = __webpack_public_path__ + "img/statistics_icon_01.fc83563a.png";